/**
 * Count visible pinned playlists from hub-config sections.
 * Matches the pinned portion of each collection page (hub-config source).
 */

function countVisibleInSection(section) {
  if (!section) return 0;
  const hidden = new Set((section.hidden || []).map(String));
  return (section.playlists || []).filter((p) => {
    const id = String(p.servicePlaylistId || p.id || '');
    return id && !hidden.has(id);
  }).length;
}

function sumGroupSections(sections, group) {
  return sections
    .filter((s) => s.group === group)
    .reduce((total, section) => total + countVisibleInSection(section), 0);
}

export function computeCuratedCountsFromHub(hubConfig) {
  const sections = hubConfig?.sections;
  if (!Array.isArray(sections)) return null;

  const audiophile = countVisibleInSection(sections.find((s) => s.id === 'audiophile'));
  const styles = sumGroupSections(sections, 'genre');
  const moods = sumGroupSections(sections, 'mood');
  const seasons = sumGroupSections(sections, 'season');

  return { audiophile, styles, moods, seasons };
}

/** Show count badge only when loaded and > 0. */
export function formatSidebarCount(count) {
  return typeof count === 'number' && count > 0 ? count : undefined;
}
